import React from "react";
import moment from "moment";

const SessionList = ({ sessions, onEdit, onDelete, userData }) => {
  const sessionItems = sessions
    .slice()
    .sort(
      (a, b) => moment(a.start_date).valueOf() - moment(b.start_date).valueOf()
    );

  return (
    <div className="">
      {sessionItems.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Details</th>
                {userData.roles !== "user" && <th>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {sessionItems.map((item, index) => (
                <tr key={item.id || index}>
                  <td>{index + 1}</td>
                  <td>{moment(item.start_date).format("DD MMMM YYYY")}</td>
                  <td>{moment(item.end_date).format("DD MMMM YYYY")}</td>
                  <td>{item.details || "N/A"}</td>
                  {userData.roles !== "user" && (
                    <td>
                      <button
                        className="btn btn-sm btn-warning me-2"
                        onClick={() => onEdit(item)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => onDelete(item.id)}
                      >
                        Delete
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="alert alert-info" role="alert">
          No academic session dates have been set yet.
        </div>
      )}
    </div>
  );
};

export default SessionList;
